import { render, staticRenderFns } from "./CarbonEmission.vue?vue&type=template&id=52a2fcb6&scoped=true&"
import script from "./CarbonEmission.vue?vue&type=script&lang=ts&"
export * from "./CarbonEmission.vue?vue&type=script&lang=ts&"
import style0 from "./CarbonEmission.vue?vue&type=style&index=0&id=52a2fcb6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a2fcb6",
  null
  
)

export default component.exports